const getCookie = (name) => {
	let result = '';
	const value = `;  ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		result = parts.pop().split(';').shift();
	}

	return result;
};

export default getCookie;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/funcs/getCookie.js